export default __webpack_public_path__ + "static/media/PAN_SELECTED.1df298e8.svg";